import React, { useState } from "react";
import BulkCsvModal from "./BulkCsvModal";

const OptionCard = (props = {}) => {
  const { selected = false, onClick = () => { }, title = "", description = "", tag = "" } =
    props || {};
  return (
    <div
      className={`bulkCsvOptionCard ${selected ? "selected" : ""}`}
      onClick={onClick}
    >
      <div className="radioDot">
        {selected && <div className="radioDotInner" />}
      </div>
      <div>
        <div className="cardTitle">
          {title}
          {tag && <span className="cardTag">{tag}</span>}
        </div>
        <div className="cardDescription">{description}</div>
      </div>
    </div>
  );
};

const StepChoose = (props = {}) => {
  const { onClose = () => { }, onSingle = () => { }, onBulk = () => { } } =
    props || {};
  const [selected, setSelected] = useState("bulk");

  return (
    <BulkCsvModal
      title="Connect SMTP/IMAP inbox"
      subtitle="Choose how you'd like to add your inbox"
      onClose={onClose}
      footer={
        <button
          type="button"
          id="bulkCsvChooseContinue"
          className="bulkCsvBtnPrimary"
          onClick={() => (selected === "bulk" ? onBulk() : onSingle())}
        >
          Continue
        </button>
      }
    >
      <OptionCard
        selected={selected === "single"}
        onClick={() => setSelected("single")}
        title="Single account"
        description="Connect one inbox manually using your SMTP/IMAP credentials."
      />
      <OptionCard
        selected={selected === "bulk"}
        onClick={() => setSelected("bulk")}
        title="Bulk import via CSV"
        description="Upload a CSV to connect multiple inboxes. Works with any email provider."
        tag="Built for bulk setup"
      />
    </BulkCsvModal>
  );
};

export default StepChoose;
export { StepChoose };
